export const onboardingKeys = {
  complete: (userId) => (userId ? `onboardingComplete:${userId}` : 'onboardingComplete'),
  justCompleted: (userId) => (userId ? `justCompletedOnboarding:${userId}` : 'justCompletedOnboarding'),
  retryCount: (userId) => (userId ? `profileRetryCount:${userId}` : 'profileRetryCount'),
};

export const isOnboardingComplete = (userId) => {
  if (!userId) return false;
  return localStorage.getItem(onboardingKeys.complete(userId)) === 'true';
};

export const setOnboardingComplete = (userId) => {
  if (!userId) return;
  localStorage.setItem(onboardingKeys.complete(userId), 'true');
};

export const clearOnboardingComplete = (userId) => {
  if (!userId) return;
  localStorage.removeItem(onboardingKeys.complete(userId));
};

export const getJustCompletedOnboarding = (userId) => {
  if (!userId) return null;
  return sessionStorage.getItem(onboardingKeys.justCompleted(userId));
};

export const setJustCompletedOnboarding = (userId) => {
  if (!userId) return;
  sessionStorage.setItem(onboardingKeys.justCompleted(userId), 'true');
};

export const clearJustCompletedOnboarding = (userId) => {
  if (!userId) return;
  sessionStorage.removeItem(onboardingKeys.justCompleted(userId));
};

export const getProfileRetryCount = (userId) => {
  if (!userId) return 0;
  return parseInt(sessionStorage.getItem(onboardingKeys.retryCount(userId)) || '0', 10);
};

export const incrementProfileRetryCount = (userId) => {
  if (!userId) return 0;
  const next = getProfileRetryCount(userId) + 1;
  sessionStorage.setItem(onboardingKeys.retryCount(userId), String(next));
  return next;
};

export const clearProfileRetryCount = (userId) => {
  if (!userId) return;
  sessionStorage.removeItem(onboardingKeys.retryCount(userId));
};

